import React, { FC } from "react";

import { Checkbox, CheckboxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { ColorGray } from "./theme";

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  color: ColorGray.main,
}));

/**
 * @see Checkbox
 */
export const IgCheckbox: FC<CheckboxProps> = (props) => {
  // @ts-ignore
  const { children, ...rest } = props;

  return <StyledCheckbox {...rest}>{children}</StyledCheckbox>;
};
